import React, { Component } from 'react';
import { modalTitleRename } from '../config/TableViewConfig';
import Form from './Form';
import { IndividualForms, IndividualForm } from './Forms/individualForms/IndividualForm';
import { toast } from 'react-toastify';
import LoadingSpinner from "../utils/Loading";
import HistoryList from './Forms/HistoryList';
import { BsPencilFill, BsPlusSquare } from 'react-icons/bs';
import logger from '../logging/logger';


class Modal extends Component {
  state = { 
    schemas: {}, 
    schema: {}, 
    data: {}, 
    show: false,
    title: "Formular",
    alert: false,
    errors: {},
    showHistoryButton: false,
    showHistory: false,
    showLoading: true,
    canSave: false,
  }
  
  constructor(props) {
    super(props);

    this.formRef = React.createRef();
    this.showHistoryButton = this.showHistoryButton.bind(this);
    this.setHistoryData = this.setHistoryData.bind(this);
    this.disableSaveButton = this.disableSaveButton.bind(this);
    this.isShow = this.isShow.bind(this)

  }

  validate(props) {
    if (this.formRef.current) {
      this.formRef.current.forceUpdate();
    }
  }

  componentDidMount() {
    this.validate(this.props);

    global.emitter.on('SHOW_MODAL' + (this.props.eventSuffix ? this.props.eventSuffix : ''), (data) => {
      // logger.log("ModalMount", data, data.data.mode);
      this.setState({
        info: data.data.new,
        mode: data.data.mode ?? 'bearbeiten'
      });
      this.sourceOnClose = data.onClose;
      this.formData = data.data;
      this.formData.schema = this.props.schemas[data.data.resourceName];
      this.setState({show: true});
      this.forceUpdate();
      if (!this.props.eventSuffix) {
        global.modal = true;
        this.base = true;
      }

      //Modal Title 
      if(this.formData.resourceName in modalTitleRename){
        // logger.log('ketest', this.formData.resourceName, typeof modalTitleRename, modalTitleRename);
        this.setState({ title: modalTitleRename[this.formData.resourceName]})
      } else {
        this.setState({ title: global.capitalize(this.formData.resourceName) });
      }

      //nur bei untersuchungen soll speichern nicht gleich möglich sein
      this.setState({canSave: this.formData.resourceName === "untersuchungen"})
    })
  }

  isShow(){
    this.setState({show: !this.state.show});
  }

  componentDidUpdate(newProps){
    if(newProps !== this.props){
      this.validate(newProps)
    }
  }

  componentWillUnmount(){
    this.setState({canSave: false})
  }
  
  handleSaveClick = async () => {
    if (this.formRef && this.formRef.current) {
      try {
        this.canClose(await this.formRef.current.saveOrUpdate())
      } catch (err) {
        console.log(err)
        this.setState({errors: err?.details || [{ message: err.message || "Unbekannter Fehler" }]})
      }
    } else {
      this.onClose();
    }
  }

  showHistoryButton(show){
    this.setState({showHistoryButton: show})
  }

  toggleHistorie(){
    this.setState({showHistory: !this.state.showHistory})
  }

  setHistoryData(data){
    this.setState({showLoading: false, historyData: data})
  }

  disableSaveButton(status = false){
    // logger.log("saveBUtton", status)
    this.setState({canSave: status})
  }


  canClose(ret = undefined){
    logger.log("can?", ret)
    logger.log("canClose?", !ret || (ret && !ret.error), ret)
    if(!ret || (ret && !ret.error) ){
      global.emitter.emit('REFRESH_SCHEMA');
      this.onClose()
      toast.success("Erfolgreich gespeichert.")
    }else{
      toast.error(ret.error, {});
    }
  }

  onClose() {
    this.setState({show: false, errors: {}});
    if (this.formData) {
      delete this.formData;
      delete this.onClose;
      if (this.base) {
        delete global.modal;
      }
      if (this.sourceOnClose) {
        this.sourceOnClose();
      }
    }
  }

  render() {
    // logger.log("Modal Render", this.formData)
    if (this.formData) {
      const canEdit = global.auth.permissions?.[this.formData.resourceName]?.edit;
      const canView = global.auth.permissions?.[this.formData.resourceName]?.view;
      const viewOnly = canView && !canEdit;

      let form; 
      if(IndividualForms.includes( this.formData.resourceName )){
        form = <IndividualForm
          resourceId={this.formData.resourceId} 
          resourceName={this.formData.resourceName} 
          schemas={this.props.schemas} 
          schema={this.formData.schema} 
          ref={this.formRef} 
          helper = {this.formData.dataSet}
          formData={{}}
          functions = {{disableSaveButton: this.disableSaveButton, showHistoryButton: this.showHistoryButton, setHistoryData: this.setHistoryData}}
          viewOnly={viewOnly}
         />
      }else {
        form = <Form 
          resourceId={this.formData.resourceId} 
          resourceName={this.formData.resourceName} 
          schemas={this.props.schemas} 
          schema={this.formData.schema} 
          ref={this.formRef} 
          formData={{}} 
          viewOnly={viewOnly} />;
      }
      let errorNotice = null;
      if (this.state.errors) {
        errorNotice = (
          <div className="errorNotices">
            {Object.keys(this.state.errors).map((key, index) => {
              const err = this.state.errors[key];
              return err.label ? (
                <p key={index} className="errorNotice">
                  <span>{`${err.label}: `}</span>{`${err.status}`}
                </p>
              ) : (
                <p key={index} className="errorNotice">
                  <span>{err.message}</span>
                </p>
              );
            })}
          </div>
        );
      }

      let info = <div className="info-box alert alert-warning alert-dismissible fade show" role="alert">
            Daten wurden vorbelegt, bitte Prüfen.
            <button type="button" className="close" data-dismiss="close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button> 
          </div>

      if(!this.state.info){
        info = ''
      }

      let modalHistory = <>
        <div className={`modal-history ${this.state.showHistory ? 'w100' : ''}`}>
          <div className={`modal-history-content ${this.state.showHistory ? '' : 'hide'}`}>
            <div className="modal-header">
              <h4 className="modal-title">Historie</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleHistorie.bind(this)} >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <LoadingSpinner show={ this.state.showLoading }/>
              { this.state.historyData ? <HistoryList liste={this.state.historyData} /> : ''}
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" className="btn btn-link" data-dismiss="modal" onClick={this.toggleHistorie.bind(this)}>Zurück</button>
            </div>
          </div>
        </div>
      </>

      const titleIcon = this.state.mode === "bearbeiten" ? <BsPencilFill fontSize={16} style={{marginRight:"8px"}}/> : <BsPlusSquare fontSize={16} style={{marginRight:"8px"}}/>
      logger.log("Permission: ", this.formData.resourceName , global.auth.permissions?.[this.formData.resourceName])
      return (<>
        <div className={"modal fade " + (this.state.show ? 'show' : '')} id="modal-default" aria-modal="true" role="dialog" aria-hidden="true" style={this.state.show ? { paddingRight: 15, display: 'block' } : {}}>
          <div className="modal-dialog modal-dialog-scrollable modal-xl">
            <div className={`modal-content ${this.state.showHistory ? 'hide' : ''}`}>
              <div className="modal-header">
                <h4 className="modal-title">{ titleIcon } { this.state.title } { this.state.mode }</h4>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.onClose.bind(this)} >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
                { info }
              <div className="modal-body">
                {errorNotice}
                {form}
              </div>
              <div className="modal-footer">
                <div>
                  <button type="button" className={`btn btn-link btn-history ${this.state.showHistoryButton ? '' : 'hide'}`} onClick={this.toggleHistorie.bind(this)}><i className="fa fa-history" style={{marginLeft: "5px"}} /> Historie anzeigen</button>
                </div>
                <div>
                  <button type="button" className="btn btn-outline" data-dismiss="modal" onClick={this.onClose.bind(this)}>{viewOnly ? "Schließen" : "Abbrechen"}</button>
                  {global.auth.permissions?.[this.formData.resourceName]?.edit && 
                    <button type="button" className="btn btn-primary" onClick={this.handleSaveClick} disabled={this.state.canSave}>{global.capitalize(this.state.mode)}</button>
                  }
                </div>
              </div>
              { this.state.showHistoryButton ? modalHistory : ''}
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show" onClick={this.onClose.bind(this)} />
      </>);
    } else {
      return <span style={{display: "none"}}></span>;
    }
  }
}

export default Modal;
